export var CONTEXT = {
  '@context': 'http://schema.org'
};
export var NERDWALLET_AUTHOR_ID = 1;
export var ORGANIZATION = {
  '@id': 'https://www.nerdwallet.com/#organization',
  '@type': 'Organization',
  name: 'NerdWallet',
  legalName: 'NerdWallet, Inc.',
  url: 'https://www.nerdwallet.com',
  logo: {
    '@type': 'ImageObject',
    url: 'https://www.nerdwallet.com/assets/img/nw-logos/NW-default_og-image.jpg'
  },
  foundingDate: '2009',
  sameAs: ['https://www.facebook.com/NerdWallet', 'https://twitter.com/NerdWallet', 'https://www.pinterest.com/nerdwallet', 'http://nerdwallet.tumblr.com', 'https://www.linkedin.com/company/nerdwallet', 'https://plus.google.com/+nerdwallet', 'https://www.glassdoor.com/Overview/Working-at-NerdWallet-EI_IE687336.11,21.htm', 'https://www.instagram.com/nerdwallet'],
  founder: [{
    '@type': 'Person',
    name: 'Tim Chen'
  }],
  address: {
    '@type': 'PostalAddress',
    streetAddress: '875 Stevenson Street, 5th Floor',
    addressLocality: 'San Francisco',
    addressRegion: 'CA',
    postalCode: '94103',
    addressCountry: {
      '@type': 'Country',
      name: 'USA'
    }
  }
};